<template>
    <div class="InformationRectangle" :style="{backgroundColor: background}">
        <i class="material-icons" :style="{color: color}" >{{ icon }}</i>
        <div>
            <h3 :style="{color}">{{ title }}</h3>
            <span>{{ message }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: ['background', 'title', 'message', 'icon', 'color'],
    setup() {

    }
}
</script>

<style lang="scss" scoped >
.InformationRectangle{
    padding: 18px;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    width: 100%;
    border-radius: 10px;

    div{
        display: flex;
        flex-direction: column;
        gap: 6px;
        h3{
            font-style: normal;
            font-weight: 700;
            font-size: 16px;
            margin: 0;
        }
        span{
            font-weight: 400;
            font-size: 16px;
        }
    }
}
</style>